<template>
    <div class="modal-open">
        <div class="modal-opened" tabindex="-1" role="dialog" aria-hidden="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-rounded">
                    <div class="row">
                        <div class="col-md-12 text-center" v-if="submitted">
                            <p class="congrats_message">
                                {{'registration.congrats.first_line' | trans}}
                                <br>
                                {{'registration.congrats.second_line' | trans}}
                            </p>
                        </div>
                        <div class="col-md-12" v-if="!submitted">
                            <form enctype="multipart/form-data" novalidate>
                                <div class="modal-header">
                                    <h2 class="modal-title">{{'registration.header' | trans}}</h2>
                                </div>
                                <div class="modal-body">
                                    <div class="alert alert-danger" role="alert" v-if="errors.has('server')">
                                        {{errors.first('server')}}
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-md-12">

                                            <mdc-select v-model="user.type"
                                                        :label="'validation.attributes.user_type' | trans"
                                                        name="user_type"
                                                        :class="{'is-invalid': errors.has('user_type')}"
                                                        v-validate="'required'"
                                                        data-vv-validate-on="none"
                                                        :data-vv-as="'validation.attributes.user_type' | trans">
                                                <option v-for="type in types" :key="type.id" :value="type.value">
                                                    {{type.label}}
                                                </option>
                                            </mdc-select>

                                            <span class="invalid-feedback" v-if="errors.has('user_type')">
                                               {{ errors.first('user_type') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group row">

                                        <div class="col-md-6">
                                            <mdc-textfield v-model="user.first_name"
                                                           :label="'validation.attributes.first_name' | trans"
                                                           type="text" name="first_name"
                                                           :class="{'is-invalid': errors.has('first_name')}"
                                                           v-validate="'required|alpha_spaces|max:255'"
                                                           data-vv-validate-on="none"
                                                           :data-vv-as="'validation.attributes.first_name' | trans"/>
                                            <span class="invalid-feedback" v-if="errors.has('first_name')">
                                               {{ errors.first('first_name') }}
                                        </span>
                                        </div>

                                        <div class="col-md-6">
                                            <mdc-textfield v-model="user.last_name"
                                                           :label="'validation.attributes.last_name' | trans"
                                                           type="text" name="last_name"
                                                           :class="{'is-invalid': errors.has('last_name')}"
                                                           v-validate="'required|alpha_spaces|max:255'"
                                                           data-vv-validate-on="none"
                                                           :data-vv-as="'validation.attributes.last_name' | trans"/>

                                            <span class="invalid-feedback" v-if="errors.has('last_name')">
                                                {{ errors.first('last_name') }}
                                        </span>
                                        </div>
                                    </div>


                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <mdc-textfield v-model="user.email"
                                                           :label="'validation.attributes.email' | trans" type="text"
                                                           name="email" :class="{'is-invalid': errors.has('email')}"
                                                           v-validate="'required|email|max:255|unique_email'"
                                                           data-vv-validate-on="none"
                                                           :data-vv-as="'validation.attributes.email' | trans"/>

                                            <span class="invalid-feedback" v-if="errors.has('email')">
                                            {{ errors.first('email') }}
                                        </span>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <mdc-textfield :label="'validation.attributes.password' | trans"
                                                           type="password" name="password" v-model="user.password"
                                                           :class="{'is-invalid': errors.has('password')}"
                                                           v-validate="'required|min:8|max:16|confirmed'"
                                                           data-vv-validate-on="none"
                                                           :data-vv-as="'validation.attributes.password' | trans"/>
                                            <small class="form-text text-muted">{{'passwords.password_subscription' | trans}}</small>


                                            <span class="invalid-feedback" v-if="errors.has('password')">
                                            {{ errors.first('password') }}
                                        </span>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <mdc-textfield v-model="user.password_confirmation"
                                                           :label="'validation.attributes.password_confirmation' | trans"
                                                           type="password" name="password_confirmation"
                                                           :class="{'is-invalid': errors.has('password_confirmation')}"
                                                           v-validate="'required|min:8|max:16'" data-vv-validate-on="none"
                                                           :data-vv-as="'validation.attributes.password_confirmation' | trans"/>

                                            <span class="invalid-feedback" v-if="errors.has('password_confirmation')">
                                            {{ errors.first('password_confirmation') }}
                                        </span>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <uploader v-on:fileuploadadd="onFileUploadAdd"
                                                      v-on:fileuploaddone="onFileUploadDone"
                                                      v-on:fileuploadfail="onFileUploadFail"
                                                      v-on:fileuploadprocessfail="onFileUploadProcessFail"
                                                      v-on:fileuploadremove="onFileUploadRemove"
                                                      :class="{'is-invalid': errors.has('file')}"></uploader>
                                            <span class="invalid-feedback" v-if="errors.has('file')">
                                            {{ errors.first('file') }}
                                        </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success active text-uppercase btn-register" @click.prevent="register()"
                                            :disabled="disabled">
                                        {{'registration.header' | trans}}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {Validator} from 'vee-validate';
  import lang from '../../../lang/translator';
  import Uploader from '../../fileUpload/components/Uploader';
  import isObject from 'lodash/isObject';
  import axios from 'axios';

  export default {
    components: {Uploader},
    data() {
      return {
        user: {
          type: null,
          first_name: null,
          last_name: null,
          email: null,
          password: null,
          password_confirmation: null,
          file: null,
        },
        selected: '',
        disabled: false,
        types: [
          {id: 1, value: 'bcba', label: lang.get('registration.user_types.bcba')},
          {id: 2, value: 'independent_curator', label: lang.get('registration.user_types.independent_curator')},
        ],
        submitted: false,
      };
    },
    metaInfo: {
      title: lang.get('registration.header'),
    },
    methods: {
      register: async function() {
        this.disabled = true;
        this.errors.remove('server');
        this.clearFileError();
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }
        try {
          let isSaved = await axios.post('/registration/register', this.user);
          this.submitted = true;
        } catch ({response}) {
          let errors = response.data.errors;
          if (isObject(errors)) {
            if (errors.message) {
              this.errors.add('server', errors.message);
            } else {
              for (let key of Object.keys(errors)) {
                let {message} = errors[key];
                this.errors.add(key, message);
              }
            }
          }
          this.disabled = false;
        }
      },
      onFileUploadAdd() {
        this.disabled = true;
      },
      onFileUploadDone({name}) {
        this.disabled = false;
        this.user.file = name;
      },
      onFileUploadFail() {
        this.disabled = false;
        this.user.file = null;
      },
      onFileUploadProcessFail() {
        this.disabled = false;
        this.user.file = null;
      },
      onFileUploadRemove() {
        this.user.file = null;
      },
      addFileError(error = lang.get(
          'validation.required',
          {attribute: lang.get('validation.attributes.certificate')},
      )) {
        this.clearFileError();
        this.errors.add('file', error);
      },
      clearFileError() {
        this.errors.remove('file');
      },
        onChange(obj) {
            this.selected = obj.value;
        }
    },
    created() {
      Validator.extend('unique_email', {
        getMessage: attribute => lang.get('validation.unique_email', {attribute}),
        validate: async (email) => {
          let valid;
          try {
            let {data: response} = await axios.post('/registration/validate-email', {email});
            valid = response.data.valid;
          } catch (e) {
            valid = false;
          }
          return {valid};
        },
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/register/components/SignupForm.vue